"use strict";
/**
 * @author tatevik.marikyan
 * @since 13/03/2018
 */
Object.defineProperty(exports, "__esModule", { value: true });
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
function isCompoundField(field) {
    var fieldType = field.getType();
    return fieldType === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER || fieldType === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT
        || fieldType === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY || fieldType === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY
        || fieldType === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE || fieldType === idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING;
}
exports.isCompoundField = isCompoundField;
function isFieldValueNotEmpty(field, entity) {
    var fieldType = field.getType();
    var fieldName = field.getSystemName();
    if (fieldType === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER || fieldType === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY ||
        fieldType === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE || fieldType === idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING) {
        return entity[fieldName] && entity[fieldName] !== null;
    }
    else if (fieldType === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT || fieldType === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY) {
        return entity[fieldName] && entity[fieldName].length > 0;
    }
}
exports.isFieldValueNotEmpty = isFieldValueNotEmpty;
function isNonEmptyCompoundField(field, entity) {
    var fieldType = field.getType();
    var fieldName = field.getSystemName();
    return ((fieldType === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER
        || fieldType === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT
        || fieldType === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY
        || fieldType === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY
        || fieldType === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE
        || fieldType === idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING)
        &&
            entity[fieldName] && entity[fieldName] !== null);
}
exports.isNonEmptyCompoundField = isNonEmptyCompoundField;
function isClassifier(field) {
    var fieldType = field.getType();
    return fieldType === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER || fieldType === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE || fieldType === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT;
}
exports.isClassifier = isClassifier;
function isMainEntity(field) {
    var fieldType = field.getType();
    return fieldType === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY;
}
exports.isMainEntity = isMainEntity;
//# sourceMappingURL=serialization-helper.js.map